import Swiper from "swiper/js/swiper.min";

export default {
    init() {
        $(".post-slider-wrapper").each(function () {
            let $mainSwiperElem = $('.post-slider', $(this));
            let $thumbnailSwiperElem = $(".post-thumbnail-slides", $(this));

            // create thumbnail slider
            let thumbnailGallery = new Swiper($thumbnailSwiperElem, {
                freeMode: true,
                slidesPerView: 6,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                spaceBetween: 10,
            });

            // create main slider
            new Swiper($mainSwiperElem, {
                autoHeight: true,
                slidesPerView: 'auto',
                thumbs: {
                    swiper: thumbnailGallery,
                },
            });
        })
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/singlePost.js